import { useMemo } from 'react';
import { useDesign } from '../../context/DesignContext';
import { validateDesign } from '../../lib/validation';

export function ValidationPanel() {
  const design = useDesign();
  const result = useMemo(() => validateDesign(design), [design]);

  return (
    <div>
      {result.errors.length === 0 ? (
        <p className="success">✓ Design ist druckbereit</p>
      ) : (
        <ul style={{ paddingLeft: '1.25rem', margin: 0 }}>
          {result.errors.map((e, i) => (
            <li key={i} className="error">
              {e}
            </li>
          ))}
        </ul>
      )}
      {result.warnings.map((w, i) => (
        <p key={i} className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.25rem' }}>
          ⚠ {w}
        </p>
      ))}
    </div>
  );
}
